import { getMonthes } from 'reactApp/utils/Period';

export function formatPrice(value?: number, locale?: string): string {
    if (!value && value !== 0) {
        return '';
    }

    const price = Number(value).toFixed(0);

    return Number(price).toLocaleString(locale);
}

export function getMonthProductPrice(product) {
    const period = product.discountPeriod || product.period;
    const months = getMonthes(period);
    const price = product.discountPrice || product.price;

    return price / months;
}
